// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:22
import { Schedule_abstract } from './../abstract/SagaSchema/Schedule_abstract';
export class Schedule extends Schedule_abstract {}
